import type { ChangeEvent } from "react";

/** Clears string from non-numeric characters, allows only one dot (for decimal part) */
const stringToNumber = (value?: string): string => {
  if (value === "" || typeof value === "undefined") return "";

  const numsWithDots = value.replace(/[^0-9.]/g, "");
  const firstDotIndex = numsWithDots.indexOf(".");
  const numValue =
    firstDotIndex !== -1
      ? numsWithDots.substring(0, firstDotIndex + 1) + numsWithDots.substring(firstDotIndex + 1).replace(/\./g, "")
      : numsWithDots;

  const parts = numValue.split(".");
  const integerPart = parts[0].replace(/^0+(?!$)/, "") || "0";
  const decimalPart = (parts[1] || "").substring(0, 2);

  if (numValue.endsWith(".") && parts.length <= 2) {
    return `${integerPart}.`;
    // biome-ignore lint/style/noUselessElse: This is a false positive
  } else if (decimalPart) {
    return `${integerPart}.${decimalPart}`;
  }
  return integerPart;
};

type Options = {
  /** Defaults to `false` */
  allowDecimal?: boolean;
};

type CreateNumberOnChange = (
  onValueChange: (numberAsString: string) => void,
  options?: Options,
) => (event: ChangeEvent<HTMLInputElement>) => void;

/** forbid non-numeric characters */
export const createNumberOnChange: CreateNumberOnChange =
  (onValueChange, options = { allowDecimal: false }) =>
  (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const clearedValue = options.allowDecimal ? stringToNumber(value) : value.replace(/[^0-9]/g, "");

    onValueChange(clearedValue);
  };
